import * as yup from 'yup'

const schema = yup.object().shape({
  description: yup.string(),
  email: yup.string().required(),
  phone: yup.string().required(),
})

export default schema
